/// <amd-module name="SuiteCommerce.PagePrinter.PDP.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.PDP.View", ["require", "exports", "sc-pageprinter-pdp.tpl", "Backbone", "SuiteCommerce.PagePrinter.PDP.Configuration", "SuiteCommerce.PagePrinter.Instrumentation"], function (require, exports, pdpTemplate, Backbone_1, PDP_Configuration_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PDPView = /** @class */ (function (_super) {
        __extends(PDPView, _super);
        function PDPView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = pdpTemplate;
            _this.events = {
                'click [data-action="printItemInfo"]': 'logClickOnPrintButton',
            };
            return _this;
        }
        PDPView.prototype.getContext = function () {
            return {
                itemId: this.model.internalId,
                buttonLabel: PDP_Configuration_1.PDPConfiguration.buttonLabel,
            };
        };
        PDPView.prototype.logClickOnPrintButton = function () {
            var log = Instrumentation_1.default.getLog('clickOnPrintButton');
            log.setParameters({
                activity: 'Click on print button',
            });
            log.submit();
        };
        return PDPView;
    }(Backbone_1.View));
    exports.PDPView = PDPView;
});
